export var ButtonType;
(function (ButtonType) {
    ButtonType["save"] = "save";
    ButtonType["default"] = "default";
    ButtonType["delete"] = "delete";
    ButtonType["upload"] = "upload";
    ButtonType["iconDataGrid"] = "iconDataGrid";
    ButtonType["iconButton"] = "iconButton";
    ButtonType["actionButton"] = "actionButton";
    ButtonType["linkButton"] = "linkButton";
    ButtonType["outlinedButton"] = "outlineButton";
    ButtonType["textButton"] = "textButton";
    ButtonType["largePrimaryDark"] = "largePrimaryDark";
    ButtonType["largePrimaryMain"] = "largePrimaryMain";
    ButtonType["largePrimaryLight"] = "largePrimaryLight";
    ButtonType["largeSecondaryDark"] = "largeSecondaryDark";
    ButtonType["largeSecondaryMain"] = "largeSecondaryMain";
    ButtonType["largeSecondaryLight"] = "largeSecondaryLight";
    ButtonType["largeErrorDark"] = "largeErrorDark";
    ButtonType["largeErrorMain"] = "largeErrorMain";
    ButtonType["largeErrorLight"] = "largeErrorLight";
    ButtonType["smallPrimaryDark"] = "smallPrimaryDark";
    ButtonType["smallPrimaryMain"] = "smallPrimaryMain";
    ButtonType["smallPrimaryLight"] = "smallPrimaryLight";
    ButtonType["smallSecondaryDark"] = "smallSecondaryDark";
    ButtonType["smallSecondaryMain"] = "smallSecondaryMain";
    ButtonType["smallSecondaryLight"] = "smallSecondaryLight";
    ButtonType["smallErrorDark"] = "smallErrorDark";
    ButtonType["smallErrorMain"] = "smallErrorMain";
    ButtonType["smallErrorLight"] = "smallErrorLight";
})(ButtonType || (ButtonType = {}));
